import React from "react"

const Progress = React.forwardRef(({ className = "", value = 0, ...props }, ref) => (
  <div ref={ref} className={`progress ${className}`} {...props}>
    <div className="progress-bar" style={{ transform: `translateX(-${100 - value}%)` }} />
  </div>
))
Progress.displayName = "Progress"

export { Progress }
